export const getHashedUrl = value => encodeURIComponent(value);
